import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "arrow"]

  toggle(event) {
    event.stopPropagation()
    const isOpen = !this.menuTarget.classList.contains("opacity-0")
    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.menuTarget.classList.remove("opacity-0", "scale-95", "pointer-events-none")
    this.menuTarget.classList.add("opacity-100", "scale-100")
    if (this.hasArrowTarget) {
      this.arrowTarget.classList.add("rotate-180")
    }
  }

  close() {
    this.menuTarget.classList.remove("opacity-100", "scale-100")
    this.menuTarget.classList.add("opacity-0", "scale-95", "pointer-events-none")
    if (this.hasArrowTarget) {
      this.arrowTarget.classList.remove("rotate-180")
    }
  }
}
